import React, { useState } from 'react';
import { FiVideo } from 'react-icons/fi';
import { adminAPI, API_ORIGIN } from '../../../../services/api';

const VideoBlockEditor = ({ block, onUpdate }) => {
    const [videoData, setVideoData] = useState({
        videoTitle: block.videoTitle || '',
        videoUrl: block.videoUrl || '',
        videoType: block.videoType || 'upload'
    });
    const [uploading, setUploading] = useState(false);

    const handleChange = (field, value) => {
        const updated = { ...videoData, [field]: value };
        setVideoData(updated);
        onUpdate(updated);
    };

    const handleFileChange = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const formData = new FormData();
        formData.append('video', file);

        try {
            setUploading(true);
            const response = await adminAPI.uploadVideo(formData);
            const url = response.data.videoUrl;

            const updated = {
                ...videoData,
                videoUrl: url,
                videoType: 'upload'
            };
            setVideoData(updated);
            onUpdate(updated);
        } catch (error) {
            console.error('Ошибка загрузки видео:', error);
            alert('Ошибка при загрузке видео. Попробуйте другой файл.');
        } finally {
            setUploading(false);
        }
    };

    return (
        <div>
            <div style={{ display: 'grid', gap: '15px' }}>
                <div>
                    <label className="form-label">Название видео</label>
                    <input
                        type="text"
                        className="form-input"
                        placeholder="Например: Объяснение Present Simple"
                        value={videoData.videoTitle}
                        onChange={(e) => handleChange('videoTitle', e.target.value)}
                    />
                </div>

                <div>
                    <label className="form-label">Видео файл</label>
                    <input
                        type="file"
                        accept="video/*"
                        className="form-input"
                        onChange={handleFileChange}
                    />
                    <p style={{ fontSize: '12px', color: '#666', marginTop: '5px' }}>
                        Загрузите видеофайл (форматы MP4, WEBM и др.). Максимальный размер файла - 100MB.
                    </p>
                    {uploading && (
                        <p style={{ fontSize: '12px', color: '#4a90e2', marginTop: '5px' }}>
                            Видео загружается...
                        </p>
                    )}
                    {videoData.videoUrl && !uploading && (
                        <p style={{ fontSize: '12px', color: '#52c41a', marginTop: '5px' }}>
                            Видео загружено.
                        </p>
                    )}
                </div>
            </div>

            {/* Превью видео */}
            {videoData.videoUrl && (
                <div style={{ marginTop: '20px' }}>
                    <label className="form-label">Превью</label>
                    <div style={{
                        borderRadius: '8px',
                        background: '#000',
                        overflow: 'hidden'
                    }}>
                        <video
                            src={videoData.videoUrl.startsWith('http')
                                ? videoData.videoUrl
                                : `${API_ORIGIN}${videoData.videoUrl}`}
                            controls
                            style={{
                                width: '100%',
                                maxHeight: '400px',
                                display: 'block'
                            }}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

export default VideoBlockEditor;